import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../api/axiosConfig';
import { useAuth } from '../context/AuthContext';

import icon from '../assets/simbol.svg';

const OnboardingPage: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [emotionalState, setEmotionalState] = useState<string[]>([]);
  const [personality, setPersonality] = useState<string[]>([]);
  const [trauma, setTrauma] = useState<string[]>([]);
  const [userName, setUserName] = useState<string>('');

  useEffect(() => {
    try {
      const fetchUser = async () => {
        const response = await axios.get('/api/users/get', { params: user });
        if (response.data) {
          setUserName(response.data.fullName);
        }
      };
      fetchUser();
    } catch (error) {
      console.log(error);
    }
  }, []);

  const handleCheckboxChange = (
    setter: React.Dispatch<React.SetStateAction<string[]>>,
    value: string
  ) => {
    setter(prev => (prev.includes(value) ? prev.filter(item => item !== value) : [...prev, value]));
  };

  const handleSubmit = async () => {
    try {
      await axios.post('/api/profiles', { emotionalState, personality, trauma });
      // Update user in local storage to reflect onboarding completion
      const userStr = localStorage.getItem('user');
      if (userStr) {
        const user = JSON.parse(userStr);
        user.hasCompletedOnboarding = true;
        localStorage.setItem('user', JSON.stringify(user));
      }
      navigate('/');
      alert('마음 프로필이 등록되었습니다.');
    } catch (error) {
      console.error('Failed to submit onboarding data:', error);
      alert('마음 프로필 등록에 실패했습니다.');
    }
  };

  const options = {
    emotionalState: [
      '불안',
      '우울',
      '무기력',
      '분노',
      '행복',
      '평온',
      '공허함',
      '만족감',
      '들뜸',
      '외로움',
      '죄책감',
      '자신감',
      '후회',
      '두려움',
      '슬픔',
      '혼란스러움',
      '서운함',
      '기대감',
      '설렘',
      '감사함',
      '좌절',
      '지루함',
      '놀람',
      '부끄러움',
    ],

    personality: [
      '내향적',
      '외향적',
      '신중함',
      '즉흥적',
      '이성적',
      '감성적',
      '계획적',
      '자유분방',
      '완벽주의',
      '낙천적',
      '비판적',
      '수용적',
      '도전적',
      '협력적',
      '독립적',
      '의존적',
      '논리적',
      '직관적',
      '모험적',
      '보수적',
      '세심함',
      '대담함',
      '융통성 있음',
    ],

    trauma: [
      '대인관계',
      '가족 문제',
      '학업/직장 스트레스',
      '과거의 상처',
      '자존감 문제',
      '진로 고민',
      '외모 콤플렉스',
      '경제적 어려움',
      '건강 문제',
      '중독 문제',
      '이별/상실',
      '왕따/따돌림',
      '폭력/학대 경험',
      '실패 경험',
      '사회적 불안',
      '우울증 경험',
      '불안장애 경험',
      '자아정체성 혼란',
      '죄책감',
      '부모와의 갈등',
    ],
  };

  return (
    <div className="onboarding-page">
      <div className="page-header">
        <img src={icon} alt="Mind Thermometer Icon" className="page-header__icon" />
        <h2 className="page-header__title">첫 방문을 환영합니다!</h2>
        <p className="page-header__subtitle">
          {' '}
          현재 <span className="user-name">{userName}</span>님을 가장 잘 나타내는 항목들을
          선택해주세요.
        </p>
      </div>
      <div>
        <div className="checklist-section">
          <h3>나의 요즘 기분</h3>
          <div className="options-container">
            {options.emotionalState.map(item => (
              <label key={item} className="checkbox-label">
                <input
                  type="checkbox"
                  onChange={() => handleCheckboxChange(setEmotionalState, item)}
                />
                {item}
              </label>
            ))}
          </div>
        </div>

        <div className="checklist-section">
          <h3>관심 주제/걱정거리 (해당 시)</h3>
          <div className="options-container">
            {options.trauma.map(item => (
              <label key={item} className="checkbox-label">
                <input type="checkbox" onChange={() => handleCheckboxChange(setTrauma, item)} />
                {item}
              </label>
            ))}
          </div>
        </div>
      </div>

      <p>
        <span className="user-name">{userName}</span>님은 어떤 사람인가요?
      </p>
      <div className="checklist-section">
        <h3>나의 성향</h3>
        <div className="options-container">
          {options.personality.map(item => (
            <label key={item} className="checkbox-label">
              <input type="checkbox" onChange={() => handleCheckboxChange(setPersonality, item)} />
              {item}
            </label>
          ))}
        </div>
      </div>

      <div className="button-container">
        <button onClick={() => navigate('/')} className="back-button">
          취소
        </button>
        <button onClick={handleSubmit} className="submit-button">
          작성 완료
        </button>
      </div>
    </div>
  );
};

export default OnboardingPage;
